import { Component, Inject, OnInit } from '@angular/core';
import { RecruitingService } from 'src/app/recruiting/recruiting.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { RecruitingState } from 'src/app/recruiting/store/recruiting.state';
import { showToasterMessage } from 'src/app/shared/actions/toaster.actions';

@Component({
    selector: 'nova-link-sample-margin-to-job',
    templateUrl: './nova-link-sample-margin-to-job.component.html',
    styleUrls: ['./nova-link-sample-margin-to-job.component.scss']
})
export class LinkSampleMarginToJobComponent implements OnInit {
    jobId: number;
    sampleMarginId: number;
    saved: boolean;

    constructor(
        private readonly _recrutingService: RecruitingService,
        public _dialogRef: MatDialogRef<LinkSampleMarginToJobComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { jobId: number },
        private readonly _store: Store<RecruitingState>
    ) {}

    ngOnInit() {
        this.jobId = this.data.jobId;
        this.saved = false;
    }

    save() {
        this.saved = true;
        this._recrutingService.linkSampleMarginToJob(this.jobId, this.sampleMarginId).subscribe({
            next: () => {
                this._dialogRef.close({
                    jobId: this.jobId,
                    sampleMarginId: this.sampleMarginId
                });
            },
            error: () => this._store.dispatch(showToasterMessage({ message: 'Unable to link to sample margin' }))
        });
    }
}
